export function updateProxyState(
	state: Record<string, unknown>,
	update: Record<string, any>
): void {
	Object.entries(update).forEach(([key, value]) => {
		state[key] = value
	})
}
